import { MahcAssessmentScoreConcept } from "@fusion-advantage/formlib"
import { useFormDispatch, useFormSelector } from "../../../redux/formStoreHooks"
import { selectMahcAssessmentDetails } from "../../../redux/selectMahcAssessment"
import { submitStatusUpdates } from "../../../redux/submitStatusUpdates"
import L3MahcAssessment from "../l3/L3MahcAssessment"
import { ConceptStatusValueType } from "../../../../../backcompat/src/ConceptStatus"

const L4MahcAssessment = () => {
	const assessmentDetails = useFormSelector(selectMahcAssessmentDetails)
	const dispatch = useFormDispatch()

	const handleScoreChange = (score: number) => {
		dispatch(submitStatusUpdates([{
			cid: MahcAssessmentScoreConcept.cid,
			value: score,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}

	return (
		<L3MahcAssessment 
			assessmentDetails={assessmentDetails} 
			onScoreChange={handleScoreChange}
		/>
	)
}

export default L4MahcAssessment